import styled from 'styled-components';

export const TabsWrapper = styled.div`
  position: relative;
  white-space: nowrap;
  margin-bottom: 44px;
`;
